import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-route-delete',
  templateUrl: './route-delete.component.html',
  styleUrls: ['./route-delete.component.css']
})
export class RouteDeleteComponent implements OnInit {

  RouteData:any = []
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleRoute: any = [];
  routeid: any = "";
  constructor(private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllRoute()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllRoute();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllRoute();
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllRoute(){
    this.generic_service.getAllRoute().subscribe(
      (res:any)=> {
        console.log(res)
        this.RouteData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  deleteroute(id:any){
    this.routeid = id
  }

  deleteRoute(){
    this.generic_service.deleteRoute(this.routeid).subscribe(
      (res:any)=>{
        console.log(res)
        this.getAllRoute()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (err:any)=> {
        console.log(err)
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  getRouteById(id:any){
    this.routeid = id
    this.generic_service.getRouteById(id).subscribe(
      (response:any)=>{
        this.singleRoute = []
        this.singleRoute.push(response.response)
        console.log(this.singleRoute)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }
}